import NoResults from '@/components/table/noResults';
import styled from 'styled-components';
import { CommitmentForecastValueDto } from '../../../../types';
import TableRow from './tableRow';
import SubTotalRow from './tableSubTotalRow';

interface TableBodyProps {
  contributionsTableData: CommitmentForecastValueDto[];
  distributionsTableData: CommitmentForecastValueDto[];
  columnWidth: number;
  openOpportunityDetailsPage: (id: string) => void;
}

const TableBody = ({ contributionsTableData, distributionsTableData, columnWidth, openOpportunityDetailsPage }: TableBodyProps) => {
  if (!contributionsTableData?.length) {
    return <NoResults />;
  }

  return (
    <TableBodyWrapper>
      <ContributionsRowWrapper>Contributions</ContributionsRowWrapper>
      {contributionsTableData.map((row) => (
        <TableRow key={row.id} row={row} columnWidth={columnWidth} openOpportunityDetailsPage={openOpportunityDetailsPage} />
      ))}
      <SubTotalRow tableData={contributionsTableData} columnWidth={columnWidth} />
      <ContributionsRowWrapper>Distribution</ContributionsRowWrapper>
      {distributionsTableData.map((row) => (
        <TableRow key={row.id} row={row} columnWidth={columnWidth} openOpportunityDetailsPage={openOpportunityDetailsPage} />
      ))}
      <SubTotalRow tableData={distributionsTableData} columnWidth={columnWidth} />
    </TableBodyWrapper>
  );
};

const TableBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ContributionsRowWrapper = styled.div`
  border-radius: 4px;
  background: ${({ theme }) => theme.layer[3]};
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 600;
  line-height: 22.4px;
  color: ${({ theme }) => theme.layer.base};
`;

export default TableBody;
